import apiClient from './apiClient';

export function createStudent(playerObject) {
  return apiClient.post('/students', playerObject);
}

export function createTeacher(playerObject) {
  return apiClient.post('/teachers', playerObject);
}

export const getPlayer = async (playerType, id) => {
  playerType = encodeURIComponent(playerType);
  id = encodeURIComponent(id);
  const { data } = await apiClient.get(`/${playerType}/${id}`);
  return data;
};

export const editPlayer = async ({ playerType, playerCode, playerObject }) => {
  playerType = encodeURIComponent(playerType);
  playerCode = encodeURIComponent(playerCode);
  const { data } = await apiClient.put(
    `/${playerType}/${playerCode}`,
    playerObject
  );
  return data;
};

export const deletePlayer = async ({ playerType, playerCode }) => {
  playerType = encodeURIComponent(playerType);
  playerCode = encodeURIComponent(playerCode);
  const { data } = await apiClient.delete(`/${playerType}/${playerCode}`);
  return data;
};

export function addPoints({ playerType, playerCode, addPointsObject }) {
  //playerType: "students" / "teachers"
  playerType = encodeURIComponent(playerType);
  playerCode = encodeURIComponent(playerCode);

  return apiClient.post(
    `/${playerType}/${playerCode}/add-points`,
    addPointsObject
  );
}
